import { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
  LeadInfoDetailsType,
  SingleClientLeadDirectoryDetails,
  UpdateSingleClientLeadDirectoryDetails,
} from "../../commonTypes/clientDirectoryTypes";
import LeadModuleForm from "../../components/LeadModule/LeadModuleForm/index";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { resetSession } from "../../redux/auth";
import { LoginResponseType } from "../../redux/auth/authTypes";
import {
  getSingleClientDirectoryLeadDetailsAction,
  resetClientDirectoryError,
  resetClientDirectoryFetching,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetLeadDirectoryList,
  resetSingleClientLeadDirectoryDetails,
  updateClientDirectoryLeadDetailsAction,
} from "../../redux/clientDirectory";
import { RootState } from "../../redux/rootReducers";
import { RadioTypes } from "../../commonTypes/universalTypes";

export const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "No",
    name: "No",
  },
  {
    id: "Yes",
    name: "Yes",
  },
];

type AppProps = {
  token: null | string;
  history: any;
  fetching: boolean;
  statusCode: number | null;
  message: string | null;
  success: number | null;
  error: null | string;
  singleClientleadDirectoryDetails: any;
  loginData: LoginResponseType;
  dispatchGetSingleClientDirectoryLeadDetailsAction: (
    data: SingleClientLeadDirectoryDetails
  ) => void;
  dispatchUpdateClientDirectoryLeadDetailsAction: (
    data: UpdateSingleClientLeadDirectoryDetails
  ) => void;
  dispatchResetSingleClientLeadDirectoryDetails: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetError: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchResetFetching: () => void;
  dispatchResetLeadList: () => void;
  dispatchResetSession: () => void;
};
const EditLeadModule = ({
  token,
  history,
  fetching,
  success,
  error,
  statusCode,
  loginData,
  singleClientleadDirectoryDetails,
  dispatchGetSingleClientDirectoryLeadDetailsAction,
  dispatchResetSingleClientLeadDirectoryDetails,
  dispatchUpdateClientDirectoryLeadDetailsAction,
  dispatchResetSuccess,
  dispatchResetError,
  dispatchResetMessage,
  dispatchResetStatusCode,
  dispatchResetSession,
}: AppProps) => {
  let { leadId }: any = useParams();
  const clientCode = leadId;
  const filterData = history?.location?.state?.multiSelectData;
  const sortByLeadReceivedOn = history?.location?.state?.sortByLeadReceivedOn;
  const tab = history?.location?.state?.tab;
  const sortByStage = history?.location?.state?.sortByStage;
  const searchData = history?.location?.state?.searchData;
  const [isGetLeadModuleDetailsPresent, setIsGetLeadModuleDetailsPresent] =
    useMenuCheck();

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetSuccess();
    setIsGetLeadModuleDetailsPresent("Get Lead Module Details", "menu");
    dispatchResetError();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetSingleClientLeadDirectoryDetails();
  }, []);

  useEffect(() => {
    if (clientCode && token) {
      const finalData = {
        token,
        clientCode,
      };
      dispatchGetSingleClientDirectoryLeadDetailsAction(finalData);
    }
  }, [clientCode]);
  const handleSubmitLeadModule = (data: LeadInfoDetailsType) => {
    const ownAccessId = singleClientleadDirectoryDetails?.access_members?.length
      ? singleClientleadDirectoryDetails?.access_members?.filter(
          (data: any) => data?.user_id === loginData?.user_id
        )
      : [];
    if (token) {
      const finalData = {
        token,
        clientCode,
        comment_count: singleClientleadDirectoryDetails?.comment_count,
        leadInfoDetails: {
          companyDetails: data?.companyDetails,
          leadDetails: data?.leadDetails,
          leadInfo: data?.leadInfo,
          accessTeamMembersId: data?.accessTeamMembersId?.length
            ? [...data?.accessTeamMembersId, ownAccessId[0]?.user_id]
            : [ownAccessId[0]?.user_id],
          attachments: data?.attachments,
          scopeOfWorkDetails:data?.scopeOfWorkDetails?data?.scopeOfWorkDetails:[],
          status: singleClientleadDirectoryDetails?.status,

        },
        businessNature: data?.businessNature,
        turnOver: data?.turnOver,
        lastComment: singleClientleadDirectoryDetails?.last_comment,
      };
      dispatchUpdateClientDirectoryLeadDetailsAction(finalData);
    }
  };



  const handleErrorModal = () => {
   
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Client Lead Updated Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetSuccess();
            history?.push({
              pathname: "/lead-module/lead-directory-list",
              search: `?tab=${tab}`,
              state: {
                filterData,
                sortByLeadReceivedOn,
                sortByStage,
                searchData,
                isPersist: true,
                tab
              },
            });
          }}
          statusCode={statusCode}
        />
      );
    }
  };

  return (
    <>
      <div className="row">
        <CommonHeader title="Edit Lead Info" />
      </div>
      {isGetLeadModuleDetailsPresent && (
        <LeadModuleForm
          history={history}
          singleClientleadDirectoryDetails={singleClientleadDirectoryDetails}
          handleSubmitLeadModule={handleSubmitLeadModule}
          loginData={loginData}
        />
      )}
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.clientDirectory.fetching,
  error: state.clientDirectory.error,
  statusCode: state.clientDirectory.statusCode,
  singleClientleadDirectoryDetails:
    state.clientDirectory.singleClientleadDirectoryDetails,
  totalCount: state.clientDirectory.leadDirectoryTotal,
  success: state.clientDirectory.success,
  message: state.clientDirectory.message,
  loginData: state.auth.loginData,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetSingleClientDirectoryLeadDetailsAction: (
    data: SingleClientLeadDirectoryDetails
  ) => dispatch(getSingleClientDirectoryLeadDetailsAction(data)),
  dispatchResetSingleClientLeadDirectoryDetails: () =>
    dispatch(resetSingleClientLeadDirectoryDetails()),
  dispatchUpdateClientDirectoryLeadDetailsAction: (
    data: UpdateSingleClientLeadDirectoryDetails
  ) => dispatch(updateClientDirectoryLeadDetailsAction(data)),
  dispatchResetSuccess: () => dispatch(resetClientDirectorySuccess()),
  dispatchResetError: () => dispatch(resetClientDirectoryError()),
  dispatchResetMessage: () => dispatch(resetClientDirectoryMessage()),
  dispatchResetStatusCode: () => dispatch(resetClientDirectoryStatusCode()),
  dispatchResetFetching: () => dispatch(resetClientDirectoryFetching()),
  dispatchResetLeadList: () => dispatch(resetLeadDirectoryList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditLeadModule);
